import { render, staticRenderFns } from "./checks.vue?vue&type=template&id=be8ed98e"
import script from "./checks.vue?vue&type=script&lang=js"
export * from "./checks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports